import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../theme';
import CardHeader, { CardHeaderProps } from '@mui/material/CardHeader';

export interface Props extends CardHeaderProps {
	headerClassName?: string;
	headingClassName?: string;
	heading: string;
}

const ModalHeading: React.FunctionComponent<Props> = ({
	heading,
	classes,
	headerClassName,
	headingClassName,
	...props
}) => {
	const { ModalHeading: css } = useTheme();

	return (
		<CardHeader
			{...props}
			classes={{
				...classes,
				root: cn(css.header, headerClassName),
				title: cn(css.heading, headingClassName)
			}}
			title={<span>{heading}</span>}
		/>
	);
};

export default ModalHeading;
